/**
 * Central, typed access to the runtime environment variables.
 *
 * Each field must be a *direct* `import.meta.env.REACT_APP_X` member access.
 * import.meta.env.REACT_APP_X is always a string, convert from string when building `env`.
 */
interface RuntimeEnv {
  /** Base URL of the Signal Viewer backend. */
  readonly baseUrl: string;
  /** m2m API key sent as the `ApiKey` header. */
  readonly apiKey: string;
  /** Client key selecting which LightningChart license to retrieve. */
  readonly licenseClientKey: string;
}

export const env: RuntimeEnv = {
  baseUrl: import.meta.env.REACT_APP_BASE_URL,
  apiKey: import.meta.env.REACT_APP_AUTH_API_KEY,
  licenseClientKey: import.meta.env.REACT_APP_LICENSE_CLIENT_KEY,
};
